import { render } from "./ResultsGrid.vue?vue&type=template&id=17b480bb"
import script from "./ResultsGrid.vue?vue&type=script&lang=js"
export * from "./ResultsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__